import styled, { css } from 'styled-components';
import { getDimension } from 'styled/helpers/getDimension';

export const BlogCardContainer = styled.div<{ isHero?: Boolean }>`
  max-width: ${({ isHero }) => (isHero ? '100%' : '350px')};

  display: flex;
  flex-direction: column;

  ${({ isHero }) =>
    isHero &&
    css`
      flex-direction: row-reverse;

      ${({ theme }) => theme.breakpoints.down('lg')} {
        flex-direction: column;
      }
    `}

  padding-bottom: ${getDimension('size10')};
  margin: ${getDimension('size3')};
  text-decoration: none;
  color: ${props => props.theme.colors.black};

  transition-property: color, text-decoration;
  transition: all 300ms;

  &:hover,
  &:focus,
  &:focus-within {
    h3 {
      color: ${props => props.theme.colors.primary};
      text-decoration: underline;
      text-decoration-thickness: 2px;
    }
  }
`;
